import { render } from "./Priority.vue?vue&type=template&id=d0a93f5c&scoped=true&lang=pug"
import script from "./Priority.vue?vue&type=script&lang=js"
export * from "./Priority.vue?vue&type=script&lang=js"

import "./Priority.vue?vue&type=style&index=0&id=d0a93f5c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0a93f5c"]])

export default __exports__